import React, { useState } from "react";
import { Image } from "./image";
import Lightbox from 'react-image-lightbox';
import "react-image-lightbox/style.css";

import { Grid, Container } from '@mui/material';

const Gallery = ({data}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setphotoIndex] = useState(0);
  const { cards : images  } = data || [];

  const hundleClick = i => {
    if (isOpen === false) {
       setIsOpen(true);
       document.body.style.overflow =  "hidden" ;
    }
    setphotoIndex(i)
  }

  const hundleClose = ()=>{
    document.body.style.overflow =  "visible";
    setIsOpen(false);
  }
  return (
    <div id="Gallery" className="text-center">
      <Container className="container fixedNavBar" sx={{"& .ReactModal__Overlay":{zIndex:1100}}}>
        <div className="section-title" style={{marginBottom: "15px"}}>
          <h2>{data ? data.title : "...loading"}</h2>
          {/* <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit duis sed
            dapibus leonec.
          </p> */}
        </div>
        <Grid  container className="portfolio-items row" spacing={0}>
            {images
              ? images.map((d, i) => (
                  <Grid
                    key={`${d.title}-${i}`}
                    xs={6}
                    md={4}
                    role='button'
                    item
                  >
                    <Image
                      title={d.title}
                      smallImage={d.img}
                      i={i}
                      hundleClick={hundleClick}
                    />
                  </Grid>
                ))
              : "Loading..."}
        </Grid>
        {isOpen && (
          <Lightbox
            mainSrc={`${process.env.REACT_APP_PUBLIC_URL}/img/gallery/${images[photoIndex].img}`}
            nextSrc={images[(photoIndex + 1) % images.length].img}
            prevSrc={images[(photoIndex + images.length - 1) % images.length].img}
            onCloseRequest={hundleClose}
            onMovePrevRequest={() => setphotoIndex((photoIndex + images.length - 1) % images.length)}
            onMoveNextRequest={() =>setphotoIndex((photoIndex + 1) % images.length)}
            enableZoom 
          />
        )}
      </Container>
    </div>
  );
};

export default Gallery
// mainSrc={`${process.env.REACT_APP_PUBLIC_URL}/img/gallery/${images[photoIndex].largeImage}`}
//             nextSrc={`${process.env.REACT_APP_PUBLIC_URL}/img/gallery/${images[(photoIndex + 1) % images.length].largeImage}`}
//             prevSrc={`${process.env.REACT_APP_PUBLIC_URL}/img/gallery/${images[(photoIndex - 1) % images.length].largeImage}`}